/*eslint-disable */

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime'
import Multiselect from 'vue-multiselect'
import axios from 'axios';
import {bus} from '@/main';
import root from '@/_helpers/roots';
import toast from '@/services/toast';
import updateProfileInfo from '@/components/private/update-profile-info-popup/index.vue';
import videoRecording from '@/components/private/video-recording-data/index.vue';

// You need a specific loader for CSS files

let appointmentApiUrl = root.appointmentApiUrl.link;
let doctorFiteredUrl = root.consultDoctorsApiUrl.link;

export default {
  name: 'therapy-for-book-appointment',
  components: {
    datetime: Datetime,
    'video-record' : videoRecording,
    'update-profile-popup' : updateProfileInfo,
    Multiselect
  },
  props: [],
  data () {
    return {
      full_name:'',
      dob:'',
      height:'',
      weight:'',
      blood_type:'',
      disease:'',
      symptoms:'',
      sendSymptomsArr:[],
      record:'',
      submitted:false,
      selfUserDetailData:{},
      datetime:'',
      subcategory:'',
      selfUserInfo:{},
      symptomsArr:[
        {name:'Fever', code:'Fever'},
        {name:'Acne', code:'Acne'},
        {name:'Blocked Nose', code:'Blocked Nose'},
        {name:'Runny Nose', code:'Runny Nose'},
        {name:'Itching', code:'Itching'},
        {name:'Headache', code:'Headache'},
        {name:'Vomiting', code:'Vomiting'},
        {name:'Constipation', code:'Constipation'},
        {name:'Throat pain', code:'Throat pain'},
        {name:'Rashes', code:'Rashes'},
        {name:'Sneezing', code:'Sneezing'},
        {name:'Hairfall', code:'Hairfall'},
        {name:'Abdominal Pain', code:'Abdominal Pain'},
        {name:'Spots On Skin', code:'Spots On Skin'},
        {name:'Obesity', code:'Obesity'},
        {name:'Gas', code:'Gas'},
        {name:'Erectile Dysfunction', code:'Erectile Dysfunction'},
        {name:'Bone Pain', code:'Bone Pain'},
        {name:'Dry Skin', code:'Dry Skin'},
      ],
      uploadedHRList:[],
      minDatetime:new Date(),
      medicalRecordsField:true,
      comment:'',
      videRecordState:false,
      videRecordData:'',
      uploadedVideoData:'',
      updatedProfilePopup:false,
      appoinmentWithID:'',
      gender:'',
      myFavDoctor:false,
      doctorDataResults:[]
    }
  },
  computed: {
  },
  mounted () {
    axios.get(doctorFiteredUrl + '?filter_type=' + 'psychiatrist').then((response) => {
      this.doctorDataResults = response.data.data.data.results
    })
    this.$store.dispatch('getSelfUserInfoApiFun').then((res)=>{
      this.selfUserInfo = res.data.data
      this.full_name = this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name
      this.dob = this.selfUserInfo.profile.dob
      this.height = this.selfUserInfo.profile.height
      this.weight = this.selfUserInfo.profile.weight
      this.blood_type = this.selfUserInfo.profile.blood_type
      this.gender = this.selfUserInfo.gender
    })
    this.$store.dispatch('getHelthRecordsListApiFun').then((res)=>{
      this.uploadedHRList = res.data.data
      if(this.uploadedHRList.length == 0){
        this.medicalRecordsField = false
      }
      return
    }).catch((err)=>{

    })
    bus.$on('videRecordDataBus', (data) => {
      this.videRecordData = data
    });
    bus.$on('videRecordStateBus', (data) => {
      this.videRecordState = data
    });
  },
  methods: { 
    customLabel ({ salutation, first_name, last_name, profile }) {
      return `${salutation} ${first_name} ${last_name} – ${profile.area_of_work}`
    },
    recordDataGetMethod(){
      if(this.record){
        let data = this.uploadedHRList.find(item => {
          if(item.id == this.record){
            this.full_name = item.first_name + ' ' + item.last_name
            this.dob = item.dob
            this.height = item.height
            this.weight = item.weight
            this.blood_type = item.blood_type
            this.gender = item.gender
          }
        });
        return data
      }else{
        this.full_name = this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name
        this.dob = this.selfUserInfo.profile.dob
        this.height = this.selfUserInfo.profile.height
        this.weight = this.selfUserInfo.profile.weight
        this.blood_type = this.selfUserInfo.profile.blood_type
        this.gender = this.selfUserInfo.gender
      }
    },
    createAppointmentFormBeforeSubmit(){
      if(this.videRecordData){
        var __self = this
        var blob = new Blob(this.videRecordData, {type: 'video/webm'})
        var reader = new FileReader();
        reader.readAsDataURL(blob); 
        reader.onloadend = function() {
          var videoBase64 = reader.result; 
          __self.uploadedVideoData = videoBase64.replace(/^data:video\/(webm);base64,/, "")
        }
      }
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted = true;
          if(this.videRecordData){
            setTimeout(()=>{
              let data = {
                full_name: this.full_name,
                dob: this.dob,
                height: this.height,
                weight: this.weight,
                blood_type: this.blood_type,
                gender:this.gender,
                disease: this.disease,
                symptoms: this.symptoms,
                medical_record:this.record,
                doctor_id:this.appoinmentWithID.id,
                appointment_time:this.datetime,
                video_file : this.uploadedVideoData,
                is_favourite:this.myFavDoctor
              }
              if(this.comment){
                data.message = this.comment;
              }
              axios.post(appointmentApiUrl, data).then((res)=>{
                toast.success(res.data.msg);
                this.closeCreateAppointmentModal()           
                this.$router.push({ name: 'onlineTherapy' })
                this.submitted =  false
              }).catch((err)=>{
                toast.error(err.data.msg || "Request Failed");
                this.submitted =  false
              })
            },100)
          }else{
            let data = {
              full_name: this.full_name,
              dob: this.dob,
              height: this.height,
              weight: this.weight,
              gender:this.gender,
              blood_type: this.blood_type,
              disease: this.disease,
              symptoms: this.symptoms,
              medical_record:this.record,
              doctor_id:this.appoinmentWithID.id,
              appointment_time:this.datetime,
              is_favourite:this.myFavDoctor
            }
            if(this.comment){
              data.message = this.comment;
            }
            axios.post(appointmentApiUrl, data).then((res)=>{
              toast.success(res.data.msg);
              this.closeCreateAppointmentModal()           
              this.$router.push({ name: 'onlineTherapy' })
              this.submitted =  false
            }).catch((err)=>{
              toast.error(err.data.msg || "Request Failed");
              this.submitted =  false
            })
          }
        return;
        }
      })
    },
    closeCreateAppointmentModal(){
      bus.$emit('bookAppointmentModalBus', false)
      document.body.classList.remove('popup_open_body')
    },
    videoRecordingPopupOpen(){
      window.scrollTo(0, 0)
      document.body.classList.add('popup_open_body')
      this.videRecordState = true
    }
  }
}